import { generatePath } from 'react-router';

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { NEW_ENTITY_ID } from 'constants/EntityTitles';
import { PATH } from 'constants/RoutesConstants';
import { putAndWait } from 'modules/app/sagas';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as types from 'modules/gates/actionTypes';
import { fetchAvailableRelays } from 'modules/kiosks/actions';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { navigate } from 'modules/router/navigate';

import { fetchGate } from '../actions/core';
import { gateDetailsIsReady } from '../actions/details';
import { GATE_DETAILS, GATE_RELAY_SELECT_ID, GATE_RELAY_SOURCE, OPENING_METHODS } from '../constants';
import { getSelectedGateId } from '../selectors/core';

/** @param {import("../types/actions").CreateGateSuccessAction} action */
function* afterCreateWorker({ payload: gate }) {
  const { id: gateId } = gate;
  yield call(navigate, generatePath(PATH.GATE_MANAGEMENT_DETAILS.path, { gateId }), { replace: true });
}

export function* initializeDetailsPage() {
  const gateId = yield select(getSelectedGateId);
  if (gateId && gateId !== NEW_ENTITY_ID) {
    const { payload: gate, error } = yield putAndWait(fetchGate(gateId, { projection: 'details' }, { target: GATE_DETAILS }));

    if (!error && gate?.config?.type === OPENING_METHODS.RELAY && gate?.dealers?.length > 0) {
      yield put(fetchAvailableRelays({
        dealerIds: gate.dealers?.map(d => d.id).join(','),
        groupId: gate.groupId,
        page: 0,
        size: 10,
        projection: 'slice',
        gateId
      }, { selectId: GATE_RELAY_SELECT_ID, source: GATE_RELAY_SOURCE }));
    }
  }
  yield put(gateDetailsIsReady());
}

function* onPageWorker() {
  yield call(initializeDetailsPage);
  yield takeLatest(types.CREATE_GATE_SUCCESS, afterCreateWorker);
}

const channelPattern = ({ type, payload }) => type === LOCATION_CHANGE && payload.action !== 'REPLACE';

export default function* gateDetailsSaga() {
  yield scopeToPage([PATH.GATE_MANAGEMENT_DETAILS], onPageWorker, undefined, channelPattern);
}
